import { IPowerIdeaPadVantageShell } from "src/app/data-models/power/power-ideapad-vantage-shell.interface";
import { FlipToBootSetStatusEnum } from "../../flipToBoot.enum";
import { FlipToBootErrorStatusInterface, FlipToBootInterface } from "../../flipToBoot.interface";
import { PowerSettingsBase } from "../power-settings.base";

export class PowerSettingsIdeapad extends PowerSettingsBase {
	constructor(private powerIdeaPadVantageShell: IPowerIdeaPadVantageShell) {
		super();
	}

	public setAlwaysOnUSBStatus(isEnabled: boolean): Promise<boolean> {
		return this.powerIdeaPadVantageShell.alwaysOnUSB.setAlwaysOnUSBStatus(isEnabled);
	}

	public async getAlwaysOnUSBCapability(): Promise<boolean> {
		const alwaysOnUSBStatus = await this.powerIdeaPadVantageShell.alwaysOnUSB.getAlwaysOnUSBStatus();
		return alwaysOnUSBStatus?.available || false;
	}

	public setUSBCharging(isEnabled: boolean): Promise<boolean> {
		return this.powerIdeaPadVantageShell.alwaysOnUSB.setUSBChargingInBatteryModeStatus(isEnabled);
	}

	public async getUSBChargingCapability(): Promise<boolean> {
		const usbChargingCapability = await this.powerIdeaPadVantageShell.alwaysOnUSB.getAlwaysOnUSBStatus();
		return usbChargingCapability?.available || false;
	}

	public setAirplaneMode(isEnabled: boolean): Promise<boolean> {
		return Promise.resolve(false);
	}

	public getAirplaneModeCapability(): Promise<boolean> {
		return Promise.resolve(false);
	}

	public setAirplaneModeAutoDetection(isEnabled: boolean): Promise<boolean> {
		return Promise.resolve(false);
	}

	public setEasyResume(isEnabled: boolean): Promise<boolean> {
		return Promise.resolve(false);
	}

	public getEasyResumeCapability(): Promise<boolean> {
		return Promise.resolve(false);
	}

	public setFlipToBoot(status: FlipToBootSetStatusEnum): Promise<FlipToBootErrorStatusInterface> {
		return this.powerIdeaPadVantageShell.flipToBoot.setFlipToBootSettings(status);
	}

	public getFlipToBoot(): Promise<FlipToBootInterface> {
		return this.powerIdeaPadVantageShell.flipToBoot.getFlipToBootCapability();
	}
}
